import css from "../images/css.png";
import express from "../images/express.png";
import html from "../images/html.png";
import js from "../images/js.png";
import mongodb from "../images/mongodb.png";
import next from "../images/next.png";
import node from "../images/node.png";
import react from "../images/react.png";
import chakra from "../images/chakra.png";
import git from "../images/git.svg";
import redux from "../images/redux.svg";
import npm from "../images/npm.svg";


const techStackArr = [
  {
    img: `${html}`,
    name: "HTML",
  },
  {
    img: `${css}`,
    name: "CSS",
  },
  {
    img: `${js}`,
    name: "JavaScript",
  },
  {
    img: `${react}`,
    name: "React.js",
  },
  {
    img: `${redux}`,
    name: "Redux",
  },
  {
    img: `${chakra}`,
    name: "chakra-UI",
  },
  {
    img: `${node}`,
    name: "node.js",
  },
  {
    img: `${express}`,
    name: "express.js",
  },
  {
    img: `${mongodb}`,
    name: "mongodb.js",
  },

  {
    img: `${next}`,
    name: "next.js",
  },

  {
    img: `${git}`,
    name: "git",
  },
  {
    img: `${npm}`,
    name: "npm",
  },
 
];

export default techStackArr;
